var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("q-icon", {
        attrs: {
          name: _vm.tenant ? "edit" : "add",
          size: "16px",
          color: "primary"
        }
      }),
      _vm._t("default"),
      _c(
        "q-popup-edit",
        {
          attrs: { buttons: "" },
          on: { show: _vm.show, save: _vm.save },
          model: {
            value: _vm.tenantPayload,
            callback: function($$v) {
              _vm.tenantPayload = $$v
            },
            expression: "tenantPayload"
          }
        },
        [
          _c("q-input", {
            attrs: { "float-label": "First name", autofocus: "" },
            model: {
              value: _vm.tenantPayload.first_name,
              callback: function($$v) {
                _vm.$set(_vm.tenantPayload, "first_name", $$v)
              },
              expression: "tenantPayload.first_name"
            }
          }),
          _c("q-input", {
            attrs: { "float-label": "Last name" },
            model: {
              value: _vm.tenantPayload.last_name,
              callback: function($$v) {
                _vm.$set(_vm.tenantPayload, "last_name", $$v)
              },
              expression: "tenantPayload.last_name"
            }
          }),
          _c("q-input", {
            attrs: { "float-label": "Email" },
            model: {
              value: _vm.tenantPayload.email,
              callback: function($$v) {
                _vm.$set(_vm.tenantPayload, "email", $$v)
              },
              expression: "tenantPayload.email"
            }
          }),
          _c("q-input", {
            attrs: { "float-label": "Phone" },
            model: {
              value: _vm.tenantPayload.phone_number,
              callback: function($$v) {
                _vm.$set(_vm.tenantPayload, "phone_number", $$v)
              },
              expression: "tenantPayload.phone_number"
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }